module.exports = __webpack_public_path__ + "media/country_flags/tr-d14ea02c.png";